import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { syncFromStorage } from "../features/auth/authSlice";
import { getDashboardPath } from "../config/dashboardRoutes";
import { useAuth } from "../hooks/useAuth";
import { tokenHandler } from "../utils/tokenHandler";

export function DashboardRouter() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { roleId, permissionId, isAuthenticated } = useAuth();

  useEffect(() => {
    const tokenValid = tokenHandler.isValid(0);

    if (!isAuthenticated || !tokenValid) {
      if (!tokenValid) {
        tokenHandler.handleExpired();
        dispatch(syncFromStorage());
      }
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      }
      return;
    }

    const dashboardPath = getDashboardPath(roleId, permissionId);
    if (location.pathname !== dashboardPath) {
      navigate(dashboardPath, { replace: true });
    }
  }, [dispatch, isAuthenticated, location.pathname, navigate, roleId, permissionId]);

  return (
    <div
      className="flex items-center justify-center min-h-screen"
      style={{ backgroundColor: "var(--color-background)" }}
    >
      <div className="text-center">
        <div className="inline-block">
          <div
            className="animate-spin rounded-full h-12 w-12 border-b-2"
            style={{ borderColor: "var(--color-primary-500)" }}
          />
        </div>
        <p className="mt-4 text-gray-600">Loading your dashboard...</p>
      </div>
    </div>
  );
}

export default DashboardRouter;
